import { DefaultMessages } from '@sheerid/jslib';

export const defaultMessagesFR: DefaultMessages = {
    address: 'Adresse',
    addressPlaceholder: 'Adresse*',
    birthDate: 'Date de naissance',
    branchOfService: 'Branch of service',
    branchOfServicePlaceholder: 'Branch Of Service*',
    changeLanguage: 'Changer de langue',
    city: 'Ville',
    cityPlaceholder: 'Ville*',
    company: 'Entreprise',
    companyPlaceholder: 'Entreprise*',
    country: 'Pays',
    countryPlaceholder: 'Pays*',
    countries: {
        CA: 'Canada',
        US: 'États-Unis',
    },
    dateTime: {
        january: 'Janvier',
        february: 'Février',
        march: 'Mars',
        april: 'Avril',
        may: 'Mai',
        june: 'Juin',
        july: 'Juillet',
        august: 'Août',
        september: 'Septembre',
        october: 'Octobre',
        november: 'Novembre',
        december: 'Décembre',
        month: 'Mois',
        day: 'Jour',
        year: 'Année',
        '2_MIN': '2 minutes',
        '20_MIN': '20 minutes',
        '2_HOURS': '2 heures',
        '24_HOURS': '24 heures',
        '3_DAY': '3 jours',
        A_FEW_MINUTES: 'quelques minutes',
        A_FEW_HOURS: 'quelques heures',
        A_FEW_DAYS: 'quelques jours',
    },
    dischargeDate: 'Date de sortie',
    emailAddress: 'Courriel',
    DOCTOR: 'Médecin',
    NURSE: 'Infirmier',
    OTHER_HEALTH_WORKER: 'Autre agent de santé',
    postalCodeExplanation: "Utilisez l'emplacement dans le fichier avec votre organisme de licence",
    emailAddressPlaceholder: 'Courriel*',
    emailExplanation: 'Nécessaire pour vous envoyer votre code unique',
    phoneNumber: 'Numéro de téléphone cellulaire',
    phoneUsPlaceholder: '555-555-5555',
    error: 'Erreur',
    limitExceededError: 'Limite de vérification dépassée',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Prénom*',
    memberId: "Numéro d'identification",
    memberIdPlaceholder: "Numéro d'identification",
    optional: 'Facultatif',
    howDoesReviewWork: 'Comment fonctionne la révision?',
    howDoesVerifyingWork: 'Comment fonctionne la vérification?',
    // tslint:disable-next-line: max-line-length
    informationTransferredToUS: 'Vos informations seront transférées aux États-Unis et seront traitées conformément à la politique de confidentialité de SheerID.',
    lastName: 'Nom de famille',
    lastNamePlaceholder: 'Nom de famille*',
    loading: 'Chargement...',
    locales: {
        'en-US': 'Anglais',
        'fr-CA': 'Français',
    },
    militaryStatus: 'Military status',
    noOptions: 'Aucune option',
    personalInformation: 'Informations personnelles',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Code postal',
    postalCodePlaceholder: 'Code postal*',
    poweredBy: 'Services de vérification effectués par SheerID',
    requiredFields: 'Tous les champs sont requis',
    school: 'School',
    schoolName: 'University / College name',
    schoolNamePlaceholder: 'University / College name*',
    sheeridFaqs: 'FAQ de SheerID',
    smsCodePlaceholder: 'SMS Code*',
    state: 'État/Province',
    statePlaceholder: 'État/Province*',
    status: 'Statut',
    statusPlaceholder: 'Statut*',
    universityName: 'University name',
    verifyAndContinue: 'Vérifier et continuer',
    verificationPurposesOnly: 'Utilisé à des fins de vérification uniquement',
    verifyMyStudentStatus: 'Verify My Student Status',
    verifyMyTeacherStatus: 'Verify My Teacher Status',
    verifyMyMembershipStatus: 'Verify My Membership Status',
    verifyMyMilitaryStatus: 'Verify My Military Status',
    verifyMyMedicalProfessionalStatus: 'VÉRIFIER MON STATUT DE PROFESSIONALES DE LA SANTÉ',
    verifyMyEmploymentStatus: 'Verify My Employee Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Military Retiree',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Active Duty',
    MILITARY_FAMILY: 'Registered Military Dependent',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Police',
    EMT: 'EMT',
    organization: 'Organisation',
    organizationPlaceholder: 'Organisation*',
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    tryAgain: 'Essayez de nouveau',
    optIn: "The North Face® fait appel à SheerID pour vérifier votre admissibilité, comme décrit dans la <a href='{sheerIdFaq}' class='sid-link' target='_blank' rel='noopener noreferrer'>FAQ de SheerID</a>. Lorsque vous fournirez vos renseignements personnels directement à SheerID à l’aide de ce formulaire, SheerID tentera de vérifier votre admissibilité, mais devra peut-être vous demander des renseignements ou des documents supplémentaires. SheerID utilisera vos renseignements personnels seulement pour vérifier votre admissibilité. SheerID transmettra vos renseignements personnels à The North Face®, qui pourrait les utiliser à d’autres fins, y compris pour vous envoyer des communications marketing, comme l'énonce la <a href='{privacyLink}' class='sid-link' target='_blank' rel='noopener noreferrer'>déclaration de confidentialité de The North Face®</a>. En cochant cette case et en cliquant sur le bouton « VÉRIFIER MON STATUT DE PROFESSIONALES DE LA SANTÉ » ci-dessus, vous acceptez <a href='{termsConditionsLink}' class='sid-link' target='_blank' rel='noopener noreferrer'>les conditions générales du programme</a> et la déclaration de confidentialité de The North Face®, en plus de consentir à recevoir des communications marketing de The North Face.®",
    errorId: {
        apiRateLimitExceeded: 'Impossible de traiter votre demande pour le moment, veuillez réessayer plus tard',
        docReviewLimitExceeded: "Limite d'examen des documents dépassée",
        expiredProgram: "Ce lien n'est plus actif",
        expiredSMSCode: 'Le code de vérification est expiré',
        failedToFetch: 'Échec de la requête HTTP',
        futureBirthDate: 'Date de naissance future',
        futureDischargeDate: 'Date de sortie future',
        internalServerError: 'Erreur interne du serveur',
        invalidAddress: 'Adresse non valide',
        invalidApiToken: "Le jeton d'API fourni était non valide ou vide",
        invalidBirthDate: 'Date de naissance non valide',
        invalidCity: 'Ville non valide',
        invalidCountry: 'Pays non valide',
        invalidDischargeDate: 'Date de sortie non valide',
        invalidDocUploadToken: "Le jeton de téléversement du document fourni n'est pas valide",
        invalidEmail: 'Courriel non valide',
        invalidFileSizeEmpty: 'Un ou plusieurs fichiers sont vides',
        invalidFileSizeMax: 'Un ou plusieurs fichiers sont trop volumineux (max : 10 Mo)',
        invalidFirstName: 'Prénom non valide',
        invalidFirstResponderStatus: 'Invalid first responder status',
        invalidLastName: 'Nom de famille non valide',
        invalidMemberId: "Numéro d'identification non valide",
        invalidMilitaryStatus: 'Invalid military status',
        invalidNumberOfFiles: 'Nombre maximum de fichiers dépassé (max : 5)',
        invalidOrganization: 'Vous devez sélectionner une organisation dans la liste',
        invalidPhoneNumber: 'Numéro de cellulaire non valide',
        invalidPostalCode: 'Code postal non valide',
        invalidProgram: 'Programme non valide',
        invalidRequest: 'Requête non valide',
        invalidSMSCode: "Le code de vérification n'a pas pu être validé",
        invalidSocialSecurityNumber: 'NAS non valide',
        invalidState: 'État/Province non valide',
        invalidStatus: 'Statut non valide',
        invalidStep: 'Étape non valide',
        marketConsentRequired: 'Consentement du marché requis',
        maxMetadataLengthExceeded: 'Dépassement de la longueur maximale des métadonnées',
        maxMetadataValuesExceeded: 'Nombre maximal de valeurs de métadonnées dépassé',
        maxSMSCodeLimitExceeded: '',
        noProgram: 'Aucun programme trouvé',
        noRemainingRewardCodes: 'Désolé, cette offre est actuellement fermée et nous ne pouvons pas vous vérifier pour le moment. Veuillez réessayer plus tard.',
        notApproved: 'Non approuvé',
        notFound: 'Pas trouvé',
        noValidFiles: 'Aucun fichier valide',
        noVerification: 'Aucune vérification trouvée',
        outsideAgePerson: "La date de naissance n'est pas éligible à cette offre.",
        requestTimeout: "Délai d'expiration de la demande",
        simulatedError: 'Ceci est une erreur simulée',
        unauthorizedDomain: 'Domaine non autorisé',
        underagePerson: 'Les personnes de moins de 16 ans ne sont pas éligibles à cette offre.',
        unknownError: 'Erreur inconnue',
        unsupportedDocMimeType: 'Un ou plusieurs fichiers sont un format non pris en charge',
        verificationLimitExceeded: 'Nous sommes ravis que vous soyez enthousiaste, mais il semble que vous ayez déjà utilisé ou tenté de profiter de cette offre.',
    },
    step: {
        personalInfo: {
            title: 'RABAIS POUR LES TRAVAILLEURS EN SANTÉ – DÉBLOQUEZ CETTE OFFRE POUR LES TRAVAILLEURS EN SANTÉ',
            subtitle: 'Vérifie que vous êtes un travailleur de la santé',
            countries: {
                US: 'États-Unis',
                CA: 'Canada',
            },
            locales: {
                'en-US': 'Anglais',
                'fr-CA': 'Français'
            },
            howDoesVerifyingWorkDetails: "Pour être admissible à cette offre, vous devez (1) être un professionnel de la santé actuellement titulaire d'un permis au Canada et (2) être membre d'une branche admissible de la profession médicale. Les succursales admissibles sont affichées dans le sélecteur de statut de ce formulaire. <br><br> The North Face utilise SheerID, un partenaire de confiance, pour vérifier que vous êtes un professionnel de la santé. SheerID ne recueille que des informations qui aident à vérifier votre éligibilité. Des informations ou documents supplémentaires peuvent être demandés.",
        },
        docUpload: {
            howDoesVerifyingWorkDetails: "L'examen des documents est géré par SheerID, un partenaire de confiance spécialisé dans la vérification des professionnels de la santé. <br><br> Les documents ne sont utilisés que pour vérifier que votre statut professionnel de la santé est à jour et seront définitivement supprimés une fois l'examen terminé. Ils ne seront pas partagés avec The North Face.",
            acceptedTypes: 'Le fichier doit être .jpg .png .pdf .gif ou .bmp',
            title: "LeNOUS AVONS BESOIN DE PLUS D'INFORMATIONS",
            subtitle: 'Les documents seront examinés par le personnel estimé de {estimatedWaitTime} chez SheerID, notre partenaire de vérification.',
            footer: null,
            rejectedSubtitle: "Nous n'avons pas pu confirmer votre admissibilité en raison de:",
            fileInstructions: 'Faites glisser et déposez vos fichiers ici ou <span class="sid-dropzone-wrap--link">parcourez</span>',
            acceptableUploadExamples: 'Des exemples acceptables comprennent:',
            cancelButtonLabel: 'ANNULER',
            submitButtonLabel: 'SOUMETTRE',
            uploadInstructions: 'Téléversez votre document émis par le gouvernement qui indique:',
            acceptableExamples: "Des exemples acceptables comprennent: <ul><li>Carte d'identité de l'école avec date d'expiration</li><li>Calendrier des cours</li><li>Reçu des frais de scolarité</li></ul>",
            estimatedWaitTime: 'Quelques minutes',
            rejectionReasons: {
                DOCUMENT_LIKELY_FRAUD: "Le document est insuffisant pour établir l'admissibilité à cette offre.",
                DOCUMENT_UNSUPPORTED: "Le document n'est pas officiel ou sur la liste des types de documents acceptés.",
                DOCUMENT_UNREADABLE: "Le document était illisible en raison d'une mauvaise qualité d'image. Veuillez vous assurer d'avoir une image clairement lisible, claire et nette et essayez de soumettre à nouveau.",
                DOCUMENT_EXPIRED: 'Le document a déjà expiré ou a été publié trop loin dans le passé. Veuillez téléverser un document plus récent.',
                DOCUMENT_TOO_FUTURE: 'La date indiquée dans le document est trop éloignée dans le futur. Veuillez téléverser un document plus récent, qui prouve votre statut actuel.',
                MISSING_DOCUMENT_DATE: 'Une date actuelle est manquante. Veuillez téléverser un document officiel daté qui prouve votre statut actuel.',
                INSUFFICIENT_DOCUMENT_DATE: 'La ou les dates indiquées dans le document sont insuffisantes pour prouver votre statut actuel. Veuillez téléverser un document qui comprend un mois et une année récents.',
                INSUFFICIENT_STATUS: 'Le document ne prouve pas que vous êtes un statut éligible à cette offre.',
                MISMATCH_STATUS: 'Le statut sur le document ne correspond pas au statut que vous avez entré sur votre formulaire de vérification.',
                INELIGIBLE_JOB_TITLE: "Le titre du poste indiqué dans le document n'est pas éligible à cette offre.",
                MISSING_INFORMATION_BIRTHDATE: 'Votre date de naissance est manquante.',
                MISMATCH_BIRTHDATE: 'La date de naissance sur le document ne correspond pas à la date de naissance que vous avez entrée sur votre formulaire de vérification.',
                OUT_OF_RANGE_BIRTHDATE: 'Votre date de naissance est en dehors de la plage acceptable de cette offre.',
                MISSING_PERSON_LAST_NAME: 'Votre nom de famille est manquant.',
                MISMATCH_PERSON_LAST_NAME: 'Le nom de famille sur le document ne correspond pas au nom de famille que vous avez entré sur votre formulaire de vérification.',
                MISSING_PERSON_FIRST_NAME: 'Votre prénom est manquant.',
                MISMATCH_PERSON_FIRST_NAME: 'Le prénom sur le document ne correspond pas au prénom que vous avez entré sur votre formulaire de vérification.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'Le nom de votre organisation est manquant.',
                MISMATCH_ORGANIZATION_NAME: "Le nom de l'organisation sur le document ne correspond pas au nom de l'organisation que vous avez entré sur votre formulaire de vérification.",
                MISMATCH_ORGANIZATION_COUNTRY: 'Le pays indiqué dans votre document ne correspond pas au pays que vous avez entré sur votre formulaire de vérification',
                MISSING_CUSTOM_VALUE: 'Le document ne contient pas les informations nécessaires pour établir votre admissibilité à cette offre.',
                MISMATCH_CUSTOM_VALUE: 'Certaines informations présentées dans le document ne correspondent pas à ce que vous avez entré dans le formulaire de vérification.',
                INSUFFICIENT_CUSTOM_VALUE: 'Le document ne contient pas les informations nécessaires pour établir votre admissibilité à cette offre.',
                DOCUMENT_VALID_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                DOCUMENT_STATUS_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                DOCUMENT_DATE_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                PERSON_BIRTHDATE_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                PERSON_LAST_NAME_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                PERSON_FIRST_NAME_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                ORGANIZATION_NAME_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",
                CUSTOM_VALUE_OTHER: "Le document est inadéquat pour établir l'admissibilité à cette offre.",

                // deprecated
                DOCUMENT_PASSWORD_PROTECTED: "Nous ne sommes pas en mesure d'accepter les documents protégés par mot de passe.",
                DOCUMENT_HANDWRITTEN: 'Nous ne pouvons pas accepter de documents manuscrits.',
                MISSING_INFORMATION: "Le document que vous avez soumis ne fournit pas toutes les informations nécessaires pour déterminer l'admissibilité à cette offre.",
                MISSING_INFORMATION_PERSON_NAME: 'Il manque un prénom et/ou un nom dans le document que vous avez soumis.',
                DOCUMENT_OUTDATED: "Le document que vous avez soumis n'a pas de date de publication ou a été publié trop loin dans le passé.",
                MISMATCH_PERSON_NAME: 'Les informations sur le document que vous avez soumis ne correspondent pas au prénom et/ou nom de famille soumis sur le formulaire de vérification.',
                MISMATCH_ORGANIZATION: "Le nom de l'organisation sur le ou les documents que vous avez soumis ne correspond pas à l'organisation que vous avez indiquée sur le formulaire de vérification.",
                INELIGIBLE_ORGANIZATION: "L'organisation sur le document que vous avez soumis n'est pas éligible à cette offre.",
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'Le document que vous avez soumis ne prouve pas votre inscription pour la période en cours.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'Les élèves du secondaire ne sont pas admissibles à cette offre.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: "Le document que vous avez soumis ne montre pas d'appartenance à une branche éligible des Forces armées américaines.",
                MISMATCH_COMPANY_NAME_OR_ADDRESS: "Le nom ou l'adresse de l'entreprise dans votre document ne correspond pas à ce que vous avez entré sur le formulaire de vérification.",
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Veuillez téléverser un talon de paye émis au cours des 30 derniers jours.',
                DOCUMENT_OUTDATED_FACULTY: "Le document que vous avez soumis ne prouve pas un emploi dans l'année universitaire en cours.",
                MISSING_OR_MISMATCH_JOB_TITLE: 'Le titre du poste sur le document que vous avez soumis est manquant ou ne correspond pas à ce que vous avez entré sur le formulaire de vérification.',
                OTHER_CONTACT_US: "Nous rencontrons des difficultés dans la vérification de votre éligibilité à l'offre. Pour toute aide, veuillez contacter le service client SheerID à l'adresse suivante : customerservice@sheerid.com.",
                PERSON_FIELD_MISMATCH: 'Un champ du document fourni ne correspondait pas à ce qui était indiqué sur le formulaire de vérification.',
            },

            uploadInfo: {
                fullName: 'Votre nom complet',
                student: {
                    enrollmentDate: 'Date proving enrollment for the current term (or within the last 3 months)',
                    school: 'Your school',
                },
                teacher: {
                    currentSchoolYear: 'A date in the current school year',
                    school: 'Your school',
                },
                military: {
                    currentAffiliation: 'Your current affiliation with the armed services',
                    dischargeDate: 'Your discharge date (if applicable)',
                    serviceBranch: 'Your branch of service',
                    uploadInstructionsDependent: 'Please upload a document that clearly shows your first name, last name, valid dates and status',
                },
                senior: {
                    birthDate: 'Your date of birth',
                },
                age: {
                    birthDate: 'Your date of birth',
                },
                firstResponder: {
                    currentAffiliation: 'Your current affiliation with that organization',
                    organization: 'Your organization',
                },
                medical: {
                    status: 'Votre statut professionnel médical',
                    validDate: 'Une date actuellement valide',
                },
                employment: {
                    company: 'Your company',
                    currentAffiliation: 'Your current affiliation with that company',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'School ID card with expiration date',
                    classSchedule: 'Class schedule',
                    tuitionReceipt: 'Tuition receipt',
                },
                teacher: {
                    idCard: 'Teacher ID card with valid date',
                    payStub: 'Pay stub from within last 60 days',
                },
                member: {
                    idCard: 'Membership Document',
                    payStub: 'Pay stub from within last 90 days',
                },
                senior: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                age: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                military: {
                    activeDuty: 'Any document that proves you are currently serving under Title 10 Active Duty Orders for 30 days or more',
                    veteran: 'Any document that proves you met the qualifications of military service and were honorably discharged',
                    reservistA: 'Any document that shows you are currently serving in the National Guard or a Reserve Component of The United States Armed Forces',
                    retiree: 'Any document that proves you are a Retiree from the US Armed Forces',
                    dependent: 'Any document that proves you are a Registered Military Dependent',
                },
                medical: {
                    licenseCertificate: 'Certificat de licence',
                    idCard: "Carte d'identité de soins infirmiers avec date d'expiration",
                    photoPayStub: "Carte d'identité avec photo et talon de paye récent",
                },
                employment: {
                    employeeIdCard: 'Employee ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    officialLetter: 'An official letter',
                },
                firstResponder: {
                    idCard: 'ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    letter: 'An official letter',
                },
            },
        },
        pending: {
            titleCountdown: 'EN TRAITEMENT',
            titleReview: 'En révision',
            subtitle: "SheerID examine vos documents pour confirmer votre statut. Ce processus peut prendre jusqu'à {maxReviewTime}.",
            subtitle2: 'Attendez ici ou laissez-nous vous informer du résultat. <br>Vous serez contacté par courriel.',
            subtitle3: 'Les informations saisies dans ce formulaire Web seront utilisées à des fins de vérification. Les informations seront partagées avec The North Face.',
            subtitleCountdown: 'Accrochez-vous pendant que nous téléversons et numérisons vos documents.',
            maxReviewTime: '24 heures',
        },
        success: {
            copyCouponCode: 'Copier le code du coupon',
            emailNotification: 'Nous vous en avons envoyé une copie par courriel afin que vous puissiez utiliser votre nouveau code maintenant ou plus tard. Recherchez le courriel de verify@sheerid.com.',
            title: 'SUCCÈS! VOUS AVEZ ÉTÉ VÉRIFIÉ!',
            subtitle: 'Voici votre code promo:',
            toRedeemTitle: 'Pour valider:',
            toRedeem1: "Cliquez sur le lien 'Appliquer un code promo' répertorié directement sous votre panier. Remarque : Votre code doit être appliqué AVANT le paiement et ne peut être utilisé qu'une seule fois.",
            toRedeem2: 'Entrez votre code promo.',
            redirectUrl: null,
            redirectButtonText: 'CONTINUER',
            verificationOnly: "SheerID gère uniquement la vérification. Maintenant que vous avez été approuvé, veuillez adresser toutes les questions concernant les conditions de promotion et/ou l'utilisation du code au service client de The North Face.",
        },
        sso: {
            title: 'Verify using your school credentials',
            subtitle: "Please sign in to your school's web portal. It will open in a new tab.",
            login: 'Sign in to my school',
        },
        collectSocialSecurityNumber: {
            title: 'Enter your social security number',
            useSsn: 'Verify using your social security number',
            uploadDoc: 'Upload a document',
            selectOption: 'Select an option',
            uploadInstead: 'Upload a document instead',
        },
        smsLoop: {
            titleWithNumber: "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
            titleWithoutNumber: "We've sent an SMS to your mobile number. Please enter the code here.",
            verificationCode: 'Verification Code',
            errors: {
                codeVerification: 'Verification code could not be validated.',
                codeExpired: 'Verification code could not be validated.',
                codeResendLimit: 'Maximum number of re-tries has been reached.',
                resend: 'Error sending the SMS message',
            },
            successResend: 'SMS message re-sent successfully',
            incorrectNumber: {
                incorrectNumber1: 'Incorrect number? Click ',
                incorrectNumber2: 'here ',
                incorrectNumber3: 'to return to {companyName}',
            },
            resendButton: 'Re-send',
            submitButton: 'Submit',
        },
    },
    ssn: 'Social Security Number',
    ssnPlaceholder: '000-00-0000',
    // The preferred default:
    infoShared: 'Information entered here will be used for verification purposes and shared with {companyName}. ',
    // region: Keep these for backward compatibility
    studentInfoShared: 'Information entered here will be used for verification purposes and shared with {companyName}. ',
    firstResponderInfoShared: 'Information entered here will be used for verification purposes. ',
    militaryInfoShared: 'Information entered here will be used for verification purposes. ',
    MedicalProfessionalInfoShared: 'Les informations saisies ici seront utilisées à des fins de vérification et partagé avec The North Face.',
    // endregion: Keep these for backward compatibility
};

